import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { router } from "./router";
import { CONFIG } from "./config";
import "./styles/index.css";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: CONFIG.cognito.userPoolId,
      userPoolClientId: CONFIG.cognito.userPoolClientId,
      loginWith: { email: true },
      signUpVerificationMethod: "code",
      passwordFormat: {
        minLength: 12,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
